import { FormApi } from 'final-form';
import { get, set } from 'lodash';
import Component from 'vue-class-component';

import { ImageTransferHelper, MediaTransferHelper } from '@skinsoft/media-transfer-helper';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { PRINCIPAL_IMAGE_CLICK_TOPIC, DELETE_IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC, MEDIA_ID_CHANGED_FROM_CACHE } from '@skinsoft/bus/src/busTopics';
import { MediaArea } from '../medias-area';
import _ from 'lodash';
import { MediaIdChangedFromCacheEvent } from '@skinsoft/ui/src/item-card/media';

export interface AddMediaEvent {
    cacheKey: string,
    newMediaId?: string
}

@Component({
    components: {
        sMediaArea: MediaArea
    },
    props: ["form", "fieldName", "entity"],
    template: require('./medias-fields-area.html')
})
export class MediasFieldsArea extends ReactiveVue {

    public fieldName: string;
    public entity: any;
    public form: FormApi;
    private $imageTransferHelper: ImageTransferHelper
    private mediaUploadInProgress: boolean = false;

    private DELETE_IMAGE_CLICK_TOPIC = DELETE_IMAGE_CLICK_TOPIC
    private IMAGE_UPLOADED_TOPIC = IMAGE_UPLOADED_TOPIC
    private PRINCIPAL_IMAGE_CLICK_TOPIC = PRINCIPAL_IMAGE_CLICK_TOPIC
    private MEDIA_ID_CHANGED_FROM_CACHE = MEDIA_ID_CHANGED_FROM_CACHE

    public get associatedMediasFieldName() {
        return `${this.fieldName}.medias`;
    }

    public get firstMediaFieldName() {
        return `${this.fieldName}.first`;
    }

    public get reportMedias() {
        let medias: any[] = this.form ? get(this.form.getState().values, this.associatedMediasFieldName ) : get(this.entity, this.associatedMediasFieldName);

        if (!medias) {
            medias = [];
            if(this.form){
                set(this.form.getState().values, this.associatedMediasFieldName, medias)
            }else{
                set(this.entity, this.associatedMediasFieldName, medias) 
            }
            return medias;
        }

        return medias
    }

    private onImageDeleteClick(event) {
        const medias = this.form ? get(this.form.getState().values, this.associatedMediasFieldName ) : get(this.entity, this.associatedMediasFieldName);
        if (medias) {
            const removedMediaId = medias.splice(event.imageListIndex, 1)
            const firstMedia = this.form ? get(this.form.getState().values, this.firstMediaFieldName ) : get(this.entity, this.firstMediaFieldName);
            if (removedMediaId === firstMedia) {
                this.modifyFirstMedia(null)
            }
        }
        this.$emit(DELETE_IMAGE_CLICK_TOPIC, event)
    }

    private onPrincipalImageClick(mediaId) {
        this.modifyFirstMedia(mediaId)
        this.$emit('imageChoice', mediaId)
    }

    private onMediaIdChangedFromCache(mediaIds: MediaIdChangedFromCacheEvent) {
        this.updateMediaFromCacheChange(mediaIds.oldMediaId, mediaIds.newMediaId)
    }

    private modifyFirstMedia(mediaId) {
        if(this.form){
            set(this.form.getState().values, this.firstMediaFieldName, mediaId)
        }else{
            _.set(this.entity, this.firstMediaFieldName, mediaId) 
        }
    }

    private updateMediaFromCacheChange(oldMediaId, newMediaId) {
        let medias = this.form ? get(this.form.getState().values, this.associatedMediasFieldName ) : get(this.entity, this.associatedMediasFieldName);
        const index = medias.indexOf(oldMediaId)
        medias.splice(index, 1)
        medias.push(newMediaId)

        const firstMedia = this.form ? get(this.form.getState().values, this.firstMediaFieldName ) : get(this.entity, this.firstMediaFieldName);
        if (firstMedia === oldMediaId) {
            this.modifyFirstMedia(newMediaId)
        }

        // save report to keep modifications
        if(this.form){
            this.form.submit();
        }
    }

    private async uploadMedia(fileData) {
        const formData = new FormData()
        formData.append("file", fileData.file)

        let medias: any[] = this.form ? get(this.form.getState().values, this.associatedMediasFieldName ) : get(this.entity, this.associatedMediasFieldName)
        if (!medias) {
            medias = []
        }
        this.mediaUploadInProgress = true
        // Retrieving temp id and uploading the media on backend asynchronously
        let cacheKey = ''
        if(window.navigator.onLine) {
            cacheKey = this.$imageTransferHelper.uploadImage(fileData.file.type, fileData.file, fileData.url)
        }
        else {
            cacheKey = this.$imageTransferHelper.uploadImageInCache(fileData.file, fileData.url)
        }
        this.mediaUploadInProgress = false

        medias.push(cacheKey)

        if(window.navigator.onLine) {
            const fileName = cacheKey.split(':')
            if(fileName) {
                const newMedia = await MediaTransferHelper.getInstance().repeatFindingMediaIdFromFileName(cacheKey.split(':')[1])
                this.$imageTransferHelper.addImageToReporterSubAlbum(newMedia.id)
                this.$emit('addMedia', {cacheKey: cacheKey, newMediaId: newMedia.id})
                return
            }
        }

        this.$emit('addMedia', { cacheKey: cacheKey })
    }
}